class Gender {
  constructor(Gender) {
    this.Gender = Gender;
  }

  isMale() {
    return this.Gender === 'M';
  }

  isFemale() {
    return this.Gender === 'F';
  }
}
export { Gender as default };
